import React from 'react';
import { Link } from 'react-router-dom';
import { numberWithCommas } from 'app/libs/number';
import qs from 'query-string';
import Button from 'app/components/common/Button';
import classNames from 'classnames/bind';
import styles from './PaymentDealerDetail.module.scss';

const cx = classNames.bind(styles);

function PaymentDealerDetail({
	firmCode,
	yearMonth,
	usageByDealerData = undefined,
	onClickArbitraryDecision,
	onClickExcel,
	onClickExcelDetail,
	onClickBillConfirm,
}) {
	return (
		<>
			<div className={cx('box_detail_dealer')}>
				<div className={cx('area_dealer')}>
					<h3 className={cx('tit_cont')}>딜러별 이용내역</h3>
					<Button
						classArray={[cx('btn_excel')]}
						title="엑셀저장(상세)"
						inline
						color="white"
						size="30"
						onClick={onClickExcelDetail}
					/>
					<Button
						classArray={[cx('btn_excel')]}
						title="엑셀저장"
						inline
						color="white"
						size="30"
						onClick={onClickExcel}
					/>
					<Button
						classArray={[cx('btn_bill')]}
						title="일괄전결"
						inline
						color="white"
						size="30"
						onClick={onClickBillConfirm}
					/>
				</div>
				<ul className={cx('dealer_history')}>
					{usageByDealerData.length === 0 && <p className={cx('no_data')}>제휴상품 이용내역이 없습니다.</p>}
					{usageByDealerData?.map((data) => {
						const linkQuery = qs.stringify({
							id: data.id,
							name: data.name,
							firmCode,
							yearMonth,
						});
						return (
							<li
								key={data.id}
								className={cx('detail_dealer')}
							>
								<strong className={cx('dealer_name')}>
									{data.name}({data.id})
								</strong>
								{data.mainUser && <span className={cx('dealer_type')}>상사대표</span>}
								<dl className={cx('history_use')}>
									<dt>이용금액</dt>
									<dd>
										<strong>{numberWithCommas(data.paymentAmount)}</strong>원
									</dd>
									<dt>등록대수</dt>
									<dd>
										<strong>{numberWithCommas(data.usageCount)}</strong>대
									</dd>
									{data.noShowCount > 0 && (
										<>
											<dt>No-Show</dt>
											<dd>
												<strong>{numberWithCommas(data.noShowCount)}</strong>대
											</dd>
										</>
									)}
								</dl>
								{data.status === 'UNCONFIRM' && (
									<div className={cx('txt_state')}>
										<span className={cx('txt_unconfirmed')}>미확인</span>
										<button
											type="button"
											onClick={() => onClickArbitraryDecision(data)}
										>
											<em className={cx('txt_add')}>(전결)</em>
										</button>
									</div>
								)}
								{data.status === 'READY' && <div className={cx('txt_state')}>조정중</div>}
								{data.status === 'COMPLETE' && (
									<div className={cx('txt_state')}>
										<em className={cx('point_checked')}>확인완료</em>
									</div>
								)}
								{data.status === 'CANCEL' && (
									<div className={cx('txt_state')}>
										<em className={cx('point_checked')}>미승인</em>
									</div>
								)}

								<Link
									to={`/my/affiliate/payment/detail?${linkQuery}`}
									className={cx('link_detail')}
								>
									자세히보기
								</Link>
							</li>
						);
					})}
				</ul>
			</div>
		</>
	);
}

export default PaymentDealerDetail;
